{
  "failed_fetch_profile": "Profiilin tietojen hakeminen epäonnistui",
  "failed_update_profile": "Profiilin tietojen päivitys epäonnistui",
  "account_information": "Tilin tiedot",
  "language": "Kieli",
  "member_since": "Jäsen alkaen",
  "account_status": "Tilin tila",
  "profile_complete": "Profiili valmis",
  "delete_account": "Poista tili",
  "delete_user_account": "Poista käyttäjätili",
  "delete_account_warning": "Kun poistat tilisi, sitä ei voi palauttaa. Ole varma.",
  "delete_user_warning": "Tämä poistaa käyttäjän tilin pysyvästi. Toimintoa ei voi perua.",
  "delete_user": "Poista käyttäjä",
  "really_delete": "Poista varmasti? ({seconds})",
  "edit_information": "Muokkaa tietoja",
  "edit_profile": "Muokkaa profiilia",
  "choose_language": "Valitse kieli",
  "security": "Turvallisuus",
  "security_coming_soon": "Turvallisuusasetukset tulevat pian saataville",
  "delete_confirmation": "Haluatko varmasti poistaa käyttäjätilisi?",
  "delete_warning": "Tätä toimintoa ei voi perua.",
  "email": "Sähköposti",
  "password": "Salasana",
  "current_password": "Vanha salasana",
  "new_password": "Uusi salasana",
  "confirm_new_password": "Vahvista uusi salasana",
  "change_password": "Vaihda salasana",
  "password_changed_successfully": "Salasana vaihdettu onnistuneesti",
  "email_change": {
    "title": "Vaihda sähköpostiosoite",
    "description": "Nykyinen osoitteesi on <strong>{{email}}</strong>. Lähetämme vahvistuslinkin uuteen osoitteeseen — osoite vaihtuu vasta, kun vahvistat sen.",
    "new_email": "Uusi sähköpostiosoite",
    "submit": "Lähetä vahvistuslinkki",
    "confirmation_sent_to": "Vahvistuslinkki lähetetty osoitteeseen <strong>{{email}}</strong>.",
    "confirmation_sent_info": "Sähköpostiosoitteesi vaihtuu, kun avaat viestissä olevan linkin. Linkki on voimassa 24 tuntia.",
    "relogin_required": "Kirjaudu ulos ja takaisin sisään Google- tai Apple-tilillä, jonka jälkeen voit vaihtaa sähköpostiosoitteen turvallisesti."
  },
  "birth_year": "Syntymävuosi",
  "date_of_birth": "Syntymäaika",
  "date_of_birth_help": "Vaaditaan ikärajoitetuissa kilpailuissa",
  "profile_image": "Profiilikuva",
  "upload_profile_image": "Lataa profiilikuva",
  "change_profile_image": "Vaihda profiilikuva",
  "remove_profile_image": "Poista profiilikuva",
  "confirm_remove_profile_image": "Haluatko varmasti poistaa profiilikuvan?",
  "profile_image_uploaded": "Profiilikuva ladattu onnistuneesti",
  "profile_image_removed": "Profiilikuva poistettu onnistuneesti",
  "upload_image_hint": "Napsauta tai vedä ja pudota kuva tähän. Enintään 5 Mt. Vain JPEG, PNG tai WebP.",
  "uploading_image": "Ladataan kuvaa...",
  "removing_image": "Poistetaan kuvaa...",
  "failed_to_upload_image": "Profiilikuvan lataaminen epäonnistui",
  "failed_to_remove_image": "Profiilikuvan poistaminen epäonnistui",
  "invalid_file_type": "Virheellinen tiedostotyyppi. Vain JPEG, PNG ja WebP-kuvat sallittu",
  "preferences": {
    "title": "Asetukset",
    "track_statistics": "Kerää kierrosstatistiikkaa",
    "track_statistics_description": "Kerää yksityiskohtaisia tilastoja (väylä, green, putit jne.) kierrokseltasi",
    "prompt_course_conditions": "Kysy kentän olosuhteet kierroksen päätteeksi",
    "prompt_course_conditions_description": "Kun päätät kierroksen, sinulta kysytään kentän olosuhteita (sää, viheriöiden nopeus jne.)",
    "statsCollection": {
      "perStat": {
        "putts": "Putit",
        "chips": "Chipit",
        "bunkerShots": "Bunkkerilyönnit",
        "penaltyStrokes": "Rangaistuslyönnit",
        "firstPutt": "Ensimmäinen putti",
        "holedPutt": "Upotettu putti",
        "gir": "Griiniosuma",
        "fir": "Väyläosuma"
      }
    }
  },
  "round_settings": {
    "private_round": "Yksityinen kierros",
    "private_round_description": "Yksityinen kierros ei näy kavereillesi"
  },
  "file_size_exceeded": "Tiedoston koko ylittää 5 Mt:n enimmäiskoon",
  "crop_profile_image": "Rajaa profiilikuva",
  "zoom": "Zoomaa",
  "preferred_units": "Ensisijainen mittayksikkö",
  "preferred_units_help": "Valitse haluatko nähdä väyläpituudet metreinä vai jaardeina",
  "units": {
    "metric": "Metrit",
    "imperial": "Jaardit"
  },
  "golfid_fields_info": "Tilisi on yhdistetty GolfID-tunnukseen. Nimi, sukupuoli, tasoitus ja syntymäaika päivittyvät automaattisesti Golfliiton rekisteristä.",
  "payment_history": {
    "title": "Maksuhistoria",
    "no_payments": "Ei maksuja",
    "load_more": "Lataa lisää",
    "competition_fee": "Kilpailumaksu",
    "green_fee": "Green fee",
    "load_failed": "Maksuhistorian lataaminen epäonnistui"
  },
  "feedback": {
    "row_label": "Lähetä palautetta kehittäjälle",
    "modal_title": "Palautelomake",
    "message_placeholder": "Kirjoita palaute palvelun kehittäjälle",
    "device_section_title": "Käyttämäni laite",
    "device_apple": "Apple (iOS)",
    "device_android": "Android",
    "device_desktop": "Tietokone",
    "wants_contact_label": "Minuun saa olla yhteydessä",
    "wants_contact_helper": "Yhteystietoja käytetään vain palautteeseesi vastaamiseen.",
    "submit": "Lähetä",
    "sending": "Lähetetään",
    "cancel": "Peruuta",
    "success": "Palaute lähetetty",
    "error": "Palautteen lähettäminen epäonnistui. Yritä uudelleen.",
    "images": {
      "label": "Liitä kuvia (valinnainen)",
      "optional_suffix": "(valinnainen)",
      "cta_mobile": "Lisää kuvia",
      "cta_desktop": "Vedä kuvia tähän tai valitse",
      "limit": "Max 3 kuvaa, 5 MB / kuva",
      "errors": {
        "too_large": "Kuva on liian suuri (max 5 MB)",
        "wrong_format": "Tuetut muodot: JPEG, PNG, WEBP",
        "too_many": "Voit lisätä enintään 3 kuvaa"
      },
      "remove_aria": "Poista kuva"
    }
  },
  "golf_id": {
    "section_title": "Yhdistä Suomi Golf ID",
    "section_title_linked": "Suomi Golf ID",
    "linked": "Yhdistetty",
    "link_button": "Yhdistä Suomi Golf ID",
    "username_label": "Suomi Golf ID -tunnus",
    "username_placeholder": "Suomi Golf ID tai sähköpostiosoite",
    "password_label": "Salasana",
    "password_placeholder": "Salasana",
    "linking": "Yhdistetään...",
    "link_success": "Golf ID yhdistetty onnistuneesti",
    "error_invalid_credentials": "Virheellinen tunnus tai salasana",
    "error_already_linked": "Tili on jo yhdistetty Golf ID:hen",
    "error_taken": "Tämä Golf ID on jo yhdistetty toiseen tiliin",
    "error_unavailable": "Golf ID -palvelu ei ole tavoitettavissa",
    "error_challenge": "Golf ID vaatii lisävahvistuksen",
    "description": "Yhdistämällä käyttäjätilit saat ajantasaisen tasoituksen ja voit lähettää tuloksia viralliseen tasoituslaskentaan.",
    "privacy_notice": "Suomi Golf ID -tunnuksiasi käytetään vain tilien yhdistämiseen eikä niitä tallenneta.",
    "forgot_password": "Unohtuiko salasana?",
    "error_invalid_format": "Syöttämäsi tunnus ei ole Suomi Golf ID -tunnus. Loydat Suomi Golf ID -tunnuksesi eBirdie-sovelluksen asetuksista."
  }
}
